import { Injectable } from "@angular/core";
import { TranslationService } from "../../../services/translation.service";
import { PermissionsService } from "../../../services/permissions.service";
import { TcmBaseComponentContext } from "./tcm-base-component-context.service";
import { TcmModalService } from "./tcm-modal.service";
import { ApiEventsService } from '../../../services/api-events.service';
import { ApiHttpClient } from "../../tcm-core.module/services/api-http-client";
import { NavigationService } from "../../tcm-core.module/services/navigation.service";
import { NotificationsService } from "../../tcm-core.module/services/notification.service";
import { BroadcastService } from "../../tcm-core.module/services/broadcast.service";

@Injectable()
export class SecureBaseComponentContext extends TcmBaseComponentContext {
    constructor(public override http: ApiHttpClient, 
        public override navService: NavigationService,
        public override notificationService: NotificationsService, 
        public override modalService: TcmModalService,
        public override broadcastService: BroadcastService, 
        public permissionService: PermissionsService, 
        public translationService: TranslationService,
        public override apiEventSvc: ApiEventsService
        ) {
        super(http, navService, notificationService, modalService, broadcastService, apiEventSvc);
    }
}
